"use strict"
const moment   = require('moment/moment');
module.exports = (type, value, format = null) => {
    try {
        if (value !== null) {
            let auxType = type.toLowerCase().trim();
            switch (auxType) {
                case 'timestamp':
                    let date = new Date(value);
                    if (!isNaN(date)) {
                        return Math.round(date.getTime() / 1000);
                    } else {
                        return value;
                    }
                    break
                case 'boolean':
                    if (typeof value === 'boolean') {
                        return value;
                    } else {
                        if (parseInt(value) <= 1) {
                            return value == true ? true : false;
                        } else {
                            throw 'Invalid value to cast Boolean must be 1 or 0'
                        }
                    }
                    break
                case 'int':
                case 'integer':
                    let newInt = parseInt(value);
                    if (!isNaN(newInt)) {
                        return newInt;
                    } else {
                        if (typeof value === 'boolean') {
                            return value == true ? 1 : 0;
                        } else {
                            throw "Invalid Number";
                        }
                    }
                    break
                case 'date':
                    return moment(value).format('YYYY-MM-DD');
                case 'datetime':
                    try {
                        let auxFormat = format ? format : "YYYY-MM-DD HH:mm:ss";
                        let dateTime  = null;
                        if (!isNaN(value)) {
                            dateTime = moment.unix(parseInt(value)).format(auxFormat);
                        } else {
                            //dateTime = moment.utc(moment(value)).format(auxFormat);
                            if (value.slice(-1) === 'Z') {
                                dateTime = moment(value).format(auxFormat);
                            } else {
                                dateTime = moment.utc(moment(value)).format(auxFormat);
                            }
                        }
                        if (dateTime !== null && dateTime.trim().toLowerCase() !== 'invalid date') {
                            return dateTime;
                        } else {
                            throw "Invalid Date"
                        }
                    } catch (err) {
                        return value
                    }
                    break
                case 'bit':
                    if (typeof value === 'boolean') {
                        return value ? 1 : 0;
                    } else if (typeof value === 'number') {
                        if (value == 1 || value == 0) {
                            return value;
                        } else {
                            throw 'invalid type of bit'
                        }
                    } else {
                        let json = value.toJSON();
                        return json.data[0];
                    }
                    break
                case 'array':
                    if (Array.isArray(value)) {
                        return value;
                    } else if (typeof value === 'string') {
                        return value.split(',');
                    } else {
                        throw "Invalid Array Format";
                    }
                    break
                case 'csv':
                    if (Array.isArray(value)) {
                        return value.join(',');
                    } else if (typeof value === 'string') {
                        return value;
                    } else {
                        throw "Invalid Array Format";
                    }
                    break
                case 'number':
                case 'decimal':
                    let val = parseFloat(value);
                    if (!isNaN(val)) {
                        return val;
                    } else {
                        throw "Invalid Number";
                    }
                case 'varchar':
                case 'string':
                case 'char':
                    if (typeof value == 'number') {
                        return `${value}`;
                    }
                    return value;
                default:
                    return value
                    break
            }
        } else {
            return null;
        }
    } catch (err) {
        return value;
    }
}